import React, { Component } from 'react';
import {connect} from 'react-redux'; 
//import GRInput from '../../Datafiles/GRInput.json';
import Box from 'grommet/components/Box';
import Image from 'grommet/components/Image';
import Button from 'grommet/components/Button';
//import Map from 'grommet/components/Map';
import ReactTooltip from 'react-tooltip';

var Grinput;
let NimbleGrPresentation;
var Rearview=false;
var Buttonlabel="Rear View";

class NimbleStorage extends Component{
    constructor(props){
      super(props);
        this.View=this.View.bind(this);
    }
    View(e){
        if(Rearview===false){
            Rearview=true;
            Buttonlabel= "Front View";
        }
        else{
            Rearview=false;
            Buttonlabel="Rear View";
        }
       this.setState({});
    }
   
    render(){
        //Grinput=GRInput
        Grinput= this.props.GRinput;
        var impath = "../img/Nimble/GRE Images/";
        var RearViewpath="../img/Nimble/GRE Images/Rear View/";
       
        //console.log(Grinput)
//        var NimbleStoragedisplay="";
         NimbleGrPresentation={
                  allArray1:[],
                  links:[]
                }      
//         var group=1;   
//         var c;
         /* Changees by Vinay, added Grinput.NimbleStorage.length!==undefined condition, for CID:10020 */
//         c= Grinput.NimbleStorage !==undefined ? Grinput.NimbleStorage.length : '';
        var allArray =[];
         var currArray=[]; var GroupId ;
         /* Changees by Vinay, added Grinput.NimbleStorage !==undefined condition, for CID:10020 */
        if(Grinput.NimbleStorage !== undefined && Grinput.NimbleStorage.length!==undefined)
        {
        for(var i=0;i<Grinput.NimbleStorage.length;i++)
        {            
            if(i===0)
            {
                currArray.push(Grinput.NimbleStorage[i]['@NimbleImageName']+'||'+Grinput.NimbleStorage[i]['@ControllerName']);
                GroupId = Grinput.NimbleStorage[i]['@Group'];
            }
            else{
                if(Grinput.NimbleStorage[i]['@Group'] === GroupId)
                {
                    currArray.push(Grinput.NimbleStorage[i]['@NimbleImageName']+'||'+Grinput.NimbleStorage[i]['@ControllerName']);
                }
                else{
                allArray.push(currArray);
                currArray =[];
                currArray.push(Grinput.NimbleStorage[i]['@NimbleImageName']+'||'+Grinput.NimbleStorage[i]['@ControllerName']);
                GroupId = Grinput.NimbleStorage[i]['@Group'];
                }
            }
        }

        // if(allArray.length>0){
        //      allArray.push(currArray);
        // }
        if(currArray.length>0){
             allArray.push(currArray);
        }
        }
        else{
            if(Grinput.NimbleStorage!==undefined)
            {
                allArray.push(Grinput.NimbleStorage['@NimbleImageName']+'||'+Grinput.NimbleStorage['@ControllerName'])
            }
        }
        NimbleGrPresentation.allArray1.push(allArray);
       let storage=[];
       let storage1=[];
             NimbleGrPresentation.allArray1[0].map((item)=>{
//                            var c=item.length;
                             var src
                     
                    if(Array.isArray(item)){
                        storage=item.map((image)=>{
                            if(Rearview===false){
                                 src=impath+image.split('||')[0];
                            }
                            else{
                                src = RearViewpath+image.split('||')[0];
                             }
                              return( <Box pad={{between:'large'}} data-tip={image.split('||')[1]}><Image src= {src}  className ="NimbleImage" size='medium'></Image></Box> );   
                        })
                     storage1.push(storage)    
                        }else{
                            if(Rearview===false){
                                 src=impath+item.split('||')[0];
                            }
                            else{
                                 src = RearViewpath+item.split('||')[0];
                             }
                    storage1.push(<Box pad={{between:'large'}} data-tip={item.split('||')[1]}><Image src= {src}  className ="NimbleImage" size='medium'></Image></Box>)

                        }

             })

        var images=storage1.map((item)=>{
           // var hovertext=
             return(<Box   pad={{between:'large'}} >{item}</Box>)
        })
       

    //    NimbleStoragedisplay=<Box  margin="none"  pad={{between:'small'}}  style={{height:'100%',width:'100%'}}>
    //                         <Box  direction='row'margin="none"calssName="storageNimble"  pad={{between:'small'}}  style={{height:'100%',width:'100%'}}>
    //                          {images}
    //                         {/*   <Map  vertical={true} data= {storage1} className="GrMap" style={{width:'100%'}}/>  */}
    //                          </Box>    
    //                         </Box>                
        
    return(
        <Box  margin="none" pad="none"  style={{height:'100%',width:'100%'}}>
                <Box    margin="none" pad="none" justify='start' align='start'  basis="1/4" style={{width:'100%'}}>    
                    <Button margin='none' pad='none' style={{marginLeft:'20px'}}  className="Viewbutton" full={true} label={Buttonlabel} onClick={this.View}/>    
                </Box>
                <ReactTooltip />    
                <Box className="storageNimble" > 
                    <Box direction='row' margin='large' justify="center" pad="none"  style={{height:'500px'}}>    
                        {images}
                     
                    </Box>
                 </Box>   
    </Box>
    );
    }
}


const mapStateToProps = (state) => {  
  return{
      
      GRinput: state.sessions.activeSession.GRInput,
     
    };
};

export default connect(mapStateToProps,null) (NimbleStorage);




// WEBPACK FOOTER //
// ./src/SizingEngineUI/SizingEngineCommonScreens/NimbleStorage.js